import { render } from "./add-staff.vue?vue&type=template&id=6755d813"
import script from "./add-staff.vue?vue&type=script&lang=js"
export * from "./add-staff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__